export default function redirect(data){
    window.location.href = data.url;
}